module.exports = __webpack_public_path__ + "static/media/FORM-FCA-007 - DECLARAÇÃO DE CIÊNCIA DE FALTAS 1.796febb2.pdf";